var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['popover', { opened: _vm.opened, top: _vm.top, right: _vm.right, centerContent: _vm.centerContent, static: _vm.static }],style:({ maxWidth: _vm.maxWidth, height: _vm.height, padding: _vm.padding })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }